import { FragmentComponent } from '@/types/graphql'

import { Waitlist } from '@/components/shared/waitlist/Waitlist'

import { BrazeCustomEventName } from '@/lib/braze/brazeConstants'

const fragment = `
  fragment WaitlistBlockFragment on WaitlistBlockRecord {
    __typename
    id
    eventName
    title
    subtitle
    ctaText
    submitCopy
  }
`

export const WaitlistBlock: FragmentComponent<{}, any> = ({ record }) => {
  return (
    <Waitlist
      brazeEventName={record.eventName as BrazeCustomEventName}
      title={record.title}
      subtitle={record.subtitle}
      ctaText={record.ctaText}
      submitCopy={record.submitCopy}
    />
  )
}

WaitlistBlock.fragment = fragment
WaitlistBlock.recordName = 'WaitlistBlockRecord'
